import { render, staticRenderFns } from "./AccountParams.vue?vue&type=template&id=12ef4912&scoped=true&"
import script from "./AccountParams.vue?vue&type=script&lang=js&"
export * from "./AccountParams.vue?vue&type=script&lang=js&"
import style0 from "./AccountParams.vue?vue&type=style&index=0&id=12ef4912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef4912",
  null
  
)

export default component.exports